exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.menu_links[data-v-1c053662]{cursor:pointer}", ""]);

// exports
